"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillTreeLevel = void 0;
var SkillTreeLevel;
(function (SkillTreeLevel) {
    SkillTreeLevel["BASIC"] = "basic";
    SkillTreeLevel["ADVANCED"] = "advanced";
    SkillTreeLevel["EXPERT"] = "expert";
})(SkillTreeLevel = exports.SkillTreeLevel || (exports.SkillTreeLevel = {}));
